import React from 'react';
import type { CFText } from '@types';
import { Collapse } from '@components/Collapse';
import Textarea from '@components/Textarea';
import { Validator } from '@components/Validator';
import useTextareaHandelrs from '@hooks/useTextareaHandelrs';
import { useCustomFeature } from '../CustomFeatureContext';
import CMoreLinkSetting from './CMoreLinkSetting';

function CTextSetting() {
  const { data, setData } = useCustomFeature<CFText>();
  const handlers = useTextareaHandelrs('trimRight', (val) =>
    setData((draft) => {
      draft.content = val;
    })
  );

  return (
    <>
      <Collapse title="文字设置">
        <Validator
          value={data.content}
          validFn={(value) => !!value}
          warningMessage="请填写文字内容"
        >
          {({ value, warning }) => (
            <Textarea
              scheme="dark"
              className="h-115"
              placeholder="请填写文字内容"
              maxLength={10000}
              value={value}
              warning={warning}
              {...handlers}
            />
          )}
        </Validator>
      </Collapse>
      <CMoreLinkSetting />
    </>
  );
}

export default CTextSetting;
